import * as angular from 'angular';
import { KendoReactDropDownTreeBridge } from './KendoReactDropDownTreeBridge';

angular
  .module('flowingly.components')
  .component('kendoReactDropdowntree', KendoReactDropDownTreeBridge);
